import React, { FC, useContext } from 'react'
import { SearchContext } from '@izettle/public-site-components/dist/help-center'

import Component from '.'
import { localeToCountryCode } from '@app/utils/i18n'
import { Blok } from '@app/typings/blok'

export const SearchOverlayWrapper: FC<Blok> = ({ reference }) => {
  const { isOpen, toggle } = useContext(SearchContext)

  if (!reference || !reference.content) {
    return null
  }

  const content = reference.content.global[0]

  return (
    <Component
      content={{
        component: content.component,
        rootNode: '#__next',
        isOpen: isOpen,
        closeModal: toggle,
        content: {
          ...content,
          language: localeToCountryCode(content.language),
        },
      }}
    />
  )
}
